import _sfc_main from "./index93.js";
/* empty css        */
import _export_sfc from "./index63.js";
const ClientForm = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-7ddb4a10"]]);
export {
  ClientForm as default
};
//# sourceMappingURL=index35.js.map
